import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type DestinationReportingDashboardController from 'lumen/controllers/destination/reporting/dashboard';
import type { LookerDashboard } from 'lumen/models';
import type { Transition } from 'lumen/services/transition';

type Params = {
  dashboard_id: string;
};

export default class DestinationReportingDashboardRoute extends Route {
  @service declare alerting: Services['alerting'];
  @service declare customReporting: Services['custom-reporting'];
  @service declare errorTracking: Services['error-tracking'];
  @service('looker-embed-session')
  declare lookerEmbedSession: Services['looker-embed-session'];
  @service declare router: Services['router'];
  @service declare store: Services['store'];

  deactivate(): void {
    this.customReporting.sidebarOpen = true;
    this.customReporting.selectedDashboard = undefined;
    this.lookerEmbedSession.onSessionExpired = undefined;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  async model({ dashboard_id }: Params) {
    try {
      const dashboard = await this.store.findRecord<LookerDashboard>(
        'looker-dashboard',
        dashboard_id,
      );

      return dashboard;
    } catch (error) {
      this.errorTracking.captureException(error);
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.alerting.showErrorAlert();
      this.router.transitionTo('destination.reporting.index');
      return undefined;
    }
  }

  resetController(controller: DestinationReportingDashboardController): void {
    void controller.acquireEmbedUrlTask.cancelAll();
    controller.reset();
  }

  setupController(
    controller: DestinationReportingDashboardController,
    model: LookerDashboard,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    this.customReporting.sidebarOpen = false;
    this.customReporting.dashboardLoading = true;
    this.customReporting.selectedDashboard = model;

    this.lookerEmbedSession.onSessionExpired = (): void => {
      void controller.acquireEmbedUrlTask.perform();
    };
    void controller.acquireEmbedUrlTask.perform();
  }
}
